import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { first, shareReplay } from "rxjs/operators";
import { AppSettingsService } from "./app-settings.service";
import { HttpService } from "./http.service";

@Injectable({
    providedIn: 'root',
})
export class PermissionService {

    private permissionConfig$: Observable<PermissionConfig>;
    private readonly PERMISSION_ENDPOINT = 'permission';
    private readonly DEVICE_PERMISSION_ENDPOINT = `${this.PERMISSION_ENDPOINT}/device`;
    constructor(private httpClient: HttpService, private appSettingsService: AppSettingsService) {
    }

    public hasDevicePermissionToFeature(deviceId: string, permission: string): Observable<CheckUserAccessResponse> {
        return this.httpClient.get<CheckUserAccessResponse>(this.appSettingsService.accountServiceUrl + this.DEVICE_PERMISSION_ENDPOINT +
            `/${deviceId}/${permission}`);
    }

    public getPermissionConfig(): Observable<PermissionConfig> {
        return this.httpClient.get<PermissionConfig>(this.appSettingsService.accountServiceUrl + this.PERMISSION_ENDPOINT + '/config');
    }

    public getPermissionConfig$() : Observable<PermissionConfig> {
        if (!this.permissionConfig$) {
            this.permissionConfig$ = this.getPermissionConfig().pipe(shareReplay(1));
            // Loads right away
            this.permissionConfig$.pipe(first()).subscribe();
        }

        return this.permissionConfig$;
    }
}

export interface CheckUserAccessResponse {
    isAllowed: boolean;
}

export interface PermissionConfig {
    techinicianPermissionIds: Array<number>;
    reporterPermissionsIds: Array<number>;
}

export const PERMISSION_CONTACTSABHADEVICE_CONSTANT = "ContactSabhaDevice";
export const PERMISSION_PROFILE_FULL_ACCESS = 'ProfileFullAccess';
export const PERMISSION_PROFILE_View_ACCESS = 'ProfileViewAccess';
export const PERMISSION_POOL_FULL_ACCESS = 'PoolFullAccess';
export const PERMISSION_POOL_VIEW_ACCESS = 'PoolViewAccess';
